export default {
  ipV4 (rule, value, callback) {
    if (value !== undefined && value !== null && value !== '') {
      if (!new RegExp('^(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)$').test(value)) {
        callback(new Error('请输入正确的IP地址'))
      }
    }
    callback()
  },
  url (rule, value, callback) {
    if (value !== undefined && value !== null && value !== '') {
      if (!new RegExp('^(https?|ftp|file)://[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]$').test(value)) {
        callback(new Error('请输入正确的网址'))
      }
    }
    callback()
  },
  port (rule, value, callback) {
    if (value !== undefined && value !== null && value !== '') {
      if (!new RegExp('^([1-9]|[1-9]\\d{1,3}|[1-5]\\d{4}|6[0-5]{2}[0-3][0-5])$').test(value)) {
        callback(new Error('端口号范围值为1-65535'))
      }
    }
    callback()
  },
  domain (rule, value, callback) {
    if (value !== undefined && value !== null && value !== '') {
      if (!new RegExp('^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$').test(value)) {
        callback(new Error('请输入正确的域名'))
      }
    }
    callback()
  },
  cidr (rule, value, callback) {
    if (value !== undefined && value !== null && value !== '') {
      if (!new RegExp('^(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)(\\/([0-9]|[1-2][0-9]|3[0-2]))$').test(value)) {
        callback(new Error('请输入正确的网段'))
      }
    }
    callback()
  },
  ipV4s (rule, value, callback) {
    if (value !== undefined && value !== null && value !== '') {
      if (!new RegExp('^(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)(((\\,)(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.(25[0-5]|2[0-4]\\d|[01]?\\d\\d?))*)$').test(value)) {
        callback(new Error('请输入一个或多个正确的IP地址，用英文逗号间隔'))
      }
    }
    callback()
  },
  ipV4Segments (rule, value, callback) {
    if (value !== undefined && value !== null && value !== '') {
      if (!new RegExp('^(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\-(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)(((\\,)(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\-(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.(25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.(25[0-5]|2[0-4]\\d|[01]?\\d\\d?))*)$').test(value)) {
        callback(new Error('请输入一个或多个正确的IP地址段，用英文逗号间隔'))
      }
    }
    callback()
  }
}
